<script>
import UserResource from '@/resources/user'
import CarResource, { CarSkinResource } from '@/resources/car'
import ResourceSearchInput from '@/components/ResourceSearchInput.vue'
import { PartyMemberResource } from '@/resources/launcher.js'

export default {
    components: {
        ResourceSearchInput
    },
    props: {
        eventResource: {
            type: Object,
            required: true
        },
        partyResource: {
            type: Object,
            required: true
        },
        noSave: Boolean
    },
    computed: {
        resources() {
            return {
                UserResource,
                CarResource,
                CarSkinResource
            }
        },
        members() {
            if (!this.partyResource) {
                return []
            }

            return this.partyResource.rel('members').resources.map((member) => {
                member.state = this.getMemberLoadingState(member)
                return member
            })
        },
        entries() {
            const manager = this.eventResource.rel('entries')
            // Must have n cells for members, not entries -- each should allow modify of event
            // Combine this form with EventForm

            if (manager.resolved) {
                return manager.resources
            }

            return []
        }
    },
    watch: {},
    data() {
        return {
            loading: true,
        }
    },
    methods: {
        async load() {
            await this.eventResource.resolveRelated()
            this.loading = false
        },
        getMemberLoadingState(member) {
            let state = null

            if (this.hasEntries) {
                if (this.entriesIndexed[member.attributes.calendar].exited) {
                    state = null
                    return state
                }
                
                if (this.entriesIndexed[member.attributes.calendar].initialized) {
                    state = false
                }
                
                if (this.entriesIndexed[member.attributes.calendar].launched) {
                    state = true
                }
            }

            return state
        },
        onFormChange() {

        },
        async save() {
            
        }
    },
    async mounted() {
        await this.load()
    }
}
</script>

<template>
    <div>
        <b-card v-for="(entry, i) in entries" :key="i" :header="entry.attributes.calendar_name" class="mb-3">
            <b-form-group label="Car" class="font-weight-bold">
                <resource-search-input
                    :to="resources.CarResource"
                    v-model="entry.attributes.car"
                    @input="onFormChange()"
                    primary-key
                />
            </b-form-group>
            <b-form-group label="User" class="font-weight-bold">
                <resource-search-input
                    :to="resources.UserResource"
                    v-model="entry.attributes.user"
                    :placeholder="entry.attributes.calendar_name"
                    @input="onFormChange()"
                    primary-key
                />
            </b-form-group>
        </b-card>
    </div>
</template>

<style lang="scss" scoped>
</style>
